/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { observable, makeObservable, action } from 'mobx';

import { debounce } from '../function-helpers';

export class AppHealth {

    protected readonly hpMaxCount: number;

    @observable hp: number;

    damage: (damageValue?: number) => void;

    constructor(hpCount = 5) {
        makeObservable(this);

        this.hpMaxCount = hpCount;
        this.hp = hpCount;

        this.damage = debounce((damageValue?: number) => {
            this.doDamage(damageValue);
        }, 500);
    }

    @action.bound
    doDamage(damageValue = 1): void {
        this.hp -= damageValue;
    }

    @action.bound
    resetHp(): void {
        this.hp = this.hpMaxCount;
    }

}
